import React from 'react';
import { insideIframe } from '@/constants';
import './index.less';
import utils from '@/common/utils';

export default function WithoutHeader({
  toIndex = () => {
    window.location.href = '/';
  },
}) {
  // 如果在iframe内不展示头部
  if (insideIframe) return null;
  return (
    <div className="outest-without-header">
      <div className="btn-collapsed-r">
        <div className="btn-collapsed-open" onClick={toIndex}>
          <img
            style={{ width: '18px' }}
            src={utils.resizeImg(
              '//img30.360buyimg.com/pop/jfs/t1/173926/17/25119/1588/61d933b4E392b5ce7/a4d9013c378a83b9.png',
              60
            )}
          />
        </div>
      </div>
    </div>
  );
}
